import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Client, ClientIndentity, IdVerifyRequestVm, XType } from 'src/app/models';
import { GenericService } from 'src/app/generic.service';



@Component({
  selector: 'app-visa-form',
  templateUrl: './visa-form.component.html',
  styles: [
  ]
})
export class VisaFormComponent implements OnInit {
  @Input() client: Client;
  @Input() identity: ClientIndentity;
  @Output() formSubmitted = new EventEmitter<any>();
  @Input() type: string;
  @Input() typeId: number;

  stateList: XType[];
  iloading = false;
  iForm: FormGroup;
  request = new IdVerifyRequestVm();

  sex: any[] = [
    { value: 'M', viewValue: 'Male' },
    { value: 'F', viewValue: 'Female' },
    { value: 'X', viewValue: 'Uni Sex' },
    { value: 'BLANK', viewValue: 'BLANK' }];


  constructor(public service: GenericService) { }

  ngOnInit(): void {
    this.service.getData('Generic/GetXTypeList/' + 'XState').then(response => {
      this.stateList = response;
    });

    this.loadForm();
  }

  get f(): any { return this.iForm.controls; }

  loadForm() {
    this.iForm = new FormGroup({
      birthDate: new FormControl(this.client.dob, [Validators.required]),
      givenName: new FormControl(this.client.firstName, [Validators.required]),
      middleName: new FormControl(null),
      familyName: new FormControl(this.client.lastName, [Validators.required]),
      passportNumber: new FormControl(null, [Validators.required]),
      countryOfIssue: new FormControl(null),

    });
  }

  submit() {
    this.iloading = true;
    this.request.type = this.type;
    this.request.typeId = this.typeId;
    this.request.identityId = this.identity.id;
    

    this.request.birthDate = this.service.getRapidDateStr(this.service.getFormValue(this.iForm.get('birthDate')));
    this.request.givenName = this.service.getFormValue(this.iForm.get('givenName'));
    this.request.middleName = this.service.getFormValue(this.iForm.get('middleName'));
    this.request.familyName = this.service.getFormValue(this.iForm.get('familyName'));
    this.request.passportNumber = this.service.getFormValue(this.iForm.get('passportNumber'));
    this.request.countryOfIssue = this.service.getFormValue(this.iForm.get('countryOfIssue'));

 
    this.service.postDataByModel('Identity/VerifyIdFromFront', this.request).then(res => {
      this.iloading = false;
      if (res.success === true) {
        this.formSubmitted.emit(res.dto.entity);
        var code = res.dto.code;
        if (code === 'Y') {
          this.service.success('ID has been verified successfully!');
        }

        if (code === 'N') {
          this.service.warn('ID has not been verified!');
        }

        if (code === 'D') {
          this.service.error('Document Error from ID Verification Provider!');
        }

        if (code === 'S') {
          this.service.error('Server Error from ID Verification Provider!');
        }
      } else {
        this.service.error(res.error);
      }
    });
  }

}
